<template>
    <ul class="leftSidebar">
        <li v-for="(item,index) in leftSidebar" :class="{'active':tabActive==item.value}" :key="index"
            @click="tabClick(item)">
            <!--<span style="width:24px;height:24px;border:1px solid red;"></span>-->
            <div>
                <!--<i class="ico_tc"></i>-->
                <svg v-if="item.value =='gd'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.525 3.5H19C19.5523 3.5 20 3.94771 20 4.5V21C20 21.5523 19.5523 22 19 22H5C4.44771 22 4 21.5523 4 21V4.5C4 3.94771 4.44771 3.5 5 3.5H8H8.5V5H15.5V3.5H16.525Z"
                        fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.00009 13.1948C8.00009 12.6425 8.44781 12.1948 9.00009 12.1948H15.0001C15.5524 12.1948 16.0001 12.6425 16.0001 13.1948C16.0001 13.7471 15.5524 14.1948 15.0001 14.1948H9.00009C8.44781 14.1948 8.00009 13.7471 8.00009 13.1948Z"
                          fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.00009 9.19482C8.00009 8.64254 8.44781 8.19482 9.00009 8.19482H15.0001C15.5524 8.19482 16.0001 8.64254 16.0001 9.19482C16.0001 9.74711 15.5524 10.1948 15.0001 10.1948H9.00009C8.44781 10.1948 8.00009 9.74711 8.00009 9.19482Z"
                          fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3 4.5C3 3.39543 3.89543 2.5 5 2.5H8.5C9.05228 2.5 9.5 2.94772 9.5 3.5V4H14.5V3.5C14.5 2.94772 14.9477 2.5 15.5 2.5H19C20.1046 2.5 21 3.39544 21 4.5V21C21 22.1046 20.1046 23 19 23H5C3.89544 23 3 22.1046 3 21V4.5ZM16.5 4.5V5C16.5 5.55228 16.0523 6 15.5 6H8.5C7.94772 6 7.5 5.55228 7.5 5V4.5H5V21H19V4.5H16.5Z"
                          fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.5 2C7.5 1.44772 7.94772 1 8.5 1H15.5C16.0523 1 16.5 1.44772 16.5 2V5C16.5 5.55228 16.0523 6 15.5 6H8.5C7.94772 6 7.5 5.55228 7.5 5V2ZM9.5 3V4H14.5V3H9.5Z"
                          fill="#2F88FF"/>
                </svg>
                <svg v-if="item.value =='gd'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.525 3.5H19C19.5523 3.5 20 3.94771 20 4.5V21C20 21.5523 19.5523 22 19 22H5C4.44771 22 4 21.5523 4 21V4.5C4 3.94771 4.44771 3.5 5 3.5H8H8.5V5H15.5V3.5H16.525Z"
                        fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.00009 13.1948C8.00009 12.6425 8.44781 12.1948 9.00009 12.1948H15.0001C15.5524 12.1948 16.0001 12.6425 16.0001 13.1948C16.0001 13.7471 15.5524 14.1948 15.0001 14.1948H9.00009C8.44781 14.1948 8.00009 13.7471 8.00009 13.1948Z"
                          fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.00009 9.19482C8.00009 8.64254 8.44781 8.19482 9.00009 8.19482H15.0001C15.5524 8.19482 16.0001 8.64254 16.0001 9.19482C16.0001 9.74711 15.5524 10.1948 15.0001 10.1948H9.00009C8.44781 10.1948 8.00009 9.74711 8.00009 9.19482Z"
                          fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3 4.5C3 3.39543 3.89543 2.5 5 2.5H8.5C9.05228 2.5 9.5 2.94772 9.5 3.5V4H14.5V3.5C14.5 2.94772 14.9477 2.5 15.5 2.5H19C20.1046 2.5 21 3.39544 21 4.5V21C21 22.1046 20.1046 23 19 23H5C3.89544 23 3 22.1046 3 21V4.5ZM16.5 4.5V5C16.5 5.55228 16.0523 6 15.5 6H8.5C7.94772 6 7.5 5.55228 7.5 5V4.5H5V21H19V4.5H16.5Z"
                          fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.5 2C7.5 1.44772 7.94772 1 8.5 1H15.5C16.0523 1 16.5 1.44772 16.5 2V5C16.5 5.55228 16.0523 6 15.5 6H8.5C7.94772 6 7.5 5.55228 7.5 5V2ZM9.5 3V4H14.5V3H9.5Z"
                          fill="#55565B"/>
                </svg>
                <svg v-if="item.value =='ry'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z"
                        fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6Z"
                          fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M2 22C2 16.4772 6.47716 12 12 12C17.5228 12 22 16.4772 22 22C22 22.5523 21.5523 23 21 23C20.4477 23 20 22.5523 20 22C20 17.5817 16.4183 14 12 14C7.58173 14 4 17.5817 4 22C4 22.5523 3.55228 23 3 23C2.44772 23 2 22.5523 2 22Z"
                          fill="#2F88FF"/>
                    <path d="M12 22L14 19.5L12 13L10 19.5L12 22Z" fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12 12C12.439 12 12.8267 12.2863 12.9558 12.7059L14.9558 19.2059C15.0531 19.5222 14.9876 19.8663 14.7809 20.1247L12.7809 22.6247C12.5911 22.8619 12.3038 23 12 23C11.6962 23 11.4089 22.8619 11.2191 22.6247L9.21914 20.1247C9.01239 19.8663 8.9469 19.5222 9.04423 19.2059L11.0442 12.7059C11.1733 12.2863 11.561 12 12 12ZM11.1114 19.2884L12 20.3992L12.8886 19.2884L12 16.4004L11.1114 19.2884Z"
                          fill="#2F88FF"/>
                </svg>
                <svg v-if="item.value =='ry'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z"
                        fill="#BEBEBE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6Z"
                          fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M2 22C2 16.4772 6.47716 12 12 12C17.5228 12 22 16.4772 22 22C22 22.5523 21.5523 23 21 23C20.4477 23 20 22.5523 20 22C20 17.5817 16.4183 14 12 14C7.58173 14 4 17.5817 4 22C4 22.5523 3.55228 23 3 23C2.44772 23 2 22.5523 2 22Z"
                          fill="#55565B"/>
                    <path d="M12 22L14 19.5L12 13L10 19.5L12 22Z" fill="#BEBEBE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12 12C12.439 12 12.8267 12.2863 12.9558 12.7059L14.9558 19.2059C15.0531 19.5222 14.9876 19.8663 14.7809 20.1247L12.7809 22.6247C12.5911 22.8619 12.3038 23 12 23C11.6962 23 11.4089 22.8619 11.2191 22.6247L9.21914 20.1247C9.01239 19.8663 8.9469 19.5222 9.04423 19.2059L11.0442 12.7059C11.1733 12.2863 11.561 12 12 12ZM11.1114 19.2884L12 20.3992L12.8886 19.2884L12 16.4004L11.1114 19.2884Z"
                          fill="#55565B"/>
                </svg>
                <svg v-if="item.value =='tc'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 5.95715L12 9.5L22 5.95715L12 2.5L2 5.95715Z" fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.6733 1.55489C11.8849 1.4817 12.1151 1.4817 12.3267 1.55489L22.3267 5.01204C22.7284 5.15088 22.9984 5.52839 23 5.95333C23.0016 6.37828 22.7345 6.75783 22.3339 6.89974L12.3339 10.4426C12.1179 10.5191 11.8821 10.5191 11.6661 10.4426L1.66605 6.89974C1.2655 6.75783 0.998385 6.37828 1.00001 5.95333C1.00163 5.52839 1.27164 5.15088 1.67326 5.01204L11.6733 1.55489ZM5.02711 5.96871L12 8.4391L18.9729 5.96871L12 3.55807L5.02711 5.96871Z"
                          fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 9.66943C1.23859 9.14816 1.80907 8.87348 2.33035 9.05593L12 12.4403L21.6696 9.05593C22.1909 8.87348 22.7614 9.14816 22.9439 9.66943C23.1263 10.1907 22.8516 10.7612 22.3303 10.9436L12.3303 14.4436C12.1165 14.5185 11.8835 14.5185 11.6696 14.4436L1.66965 10.9436C1.14837 10.7612 0.873692 10.1907 1.05614 9.66943Z"
                          fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 13.6694C1.23859 13.1482 1.80907 12.8735 2.33035 13.0559L12 16.4403L21.6696 13.0559C22.1909 12.8735 22.7614 13.1482 22.9439 13.6694C23.1263 14.1907 22.8516 14.7612 22.3303 14.9436L12.3303 18.4436C12.1165 18.5185 11.8835 18.5185 11.6696 18.4436L1.66965 14.9436C1.14837 14.7612 0.873692 14.1907 1.05614 13.6694Z"
                          fill="#2F88FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 17.6694C1.23859 17.1482 1.80907 16.8735 2.33035 17.0559L12 20.4403L21.6696 17.0559C22.1909 16.8735 22.7614 17.1482 22.9439 17.6694C23.1263 18.1907 22.8516 18.7612 22.3303 18.9436L12.3303 22.4436C12.1165 22.5185 11.8835 22.5185 11.6696 22.4436L1.66965 18.9436C1.14837 18.7612 0.873692 18.1907 1.05614 17.6694Z"
                          fill="#2F88FF"/>
                </svg>
                <svg v-if="item.value =='tc'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 5.95715L12 9.5L22 5.95715L12 2.5L2 5.95715Z" fill="#BEBEBE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.6733 1.55489C11.8849 1.4817 12.1151 1.4817 12.3267 1.55489L22.3267 5.01204C22.7284 5.15088 22.9984 5.52839 23 5.95333C23.0016 6.37828 22.7345 6.75783 22.3339 6.89974L12.3339 10.4426C12.1179 10.5191 11.8821 10.5191 11.6661 10.4426L1.66605 6.89974C1.2655 6.75783 0.998385 6.37828 1.00001 5.95333C1.00163 5.52839 1.27164 5.15088 1.67326 5.01204L11.6733 1.55489ZM5.02711 5.96871L12 8.4391L18.9729 5.96871L12 3.55807L5.02711 5.96871Z"
                          fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 9.66943C1.23859 9.14816 1.80907 8.87348 2.33035 9.05593L12 12.4403L21.6696 9.05593C22.1909 8.87348 22.7614 9.14816 22.9439 9.66943C23.1263 10.1907 22.8516 10.7612 22.3303 10.9436L12.3303 14.4436C12.1165 14.5185 11.8835 14.5185 11.6696 14.4436L1.66965 10.9436C1.14837 10.7612 0.873692 10.1907 1.05614 9.66943Z"
                          fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 13.6694C1.23859 13.1482 1.80907 12.8735 2.33035 13.0559L12 16.4403L21.6696 13.0559C22.1909 12.8735 22.7614 13.1482 22.9439 13.6694C23.1263 14.1907 22.8516 14.7612 22.3303 14.9436L12.3303 18.4436C12.1165 18.5185 11.8835 18.5185 11.6696 18.4436L1.66965 14.9436C1.14837 14.7612 0.873692 14.1907 1.05614 13.6694Z"
                          fill="#55565B"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.05614 17.6694C1.23859 17.1482 1.80907 16.8735 2.33035 17.0559L12 20.4403L21.6696 17.0559C22.1909 16.8735 22.7614 17.1482 22.9439 17.6694C23.1263 18.1907 22.8516 18.7612 22.3303 18.9436L12.3303 22.4436C12.1165 22.5185 11.8835 22.5185 11.6696 22.4436L1.66965 18.9436C1.14837 18.7612 0.873692 18.1907 1.05614 17.6694Z"
                          fill="#55565B"/>
                </svg>

                <!--<img v-if="item.value =='gd'" src="../../assets/images/ico_gd@2x.svg" alt="">-->
                <!--<img v-if="item.value =='ry'" src="../../assets/images/ico_ry.svg" alt="">-->
                <!--<img v-if="item.value =='tc'" src="../../assets/images/ico_tc.svg" alt="">-->
                <span v-text="item.nav"></span>
            </div>
            <el-icon v-show="tabActive==item.value">
                <CaretRight/>
            </el-icon>
        </li>
    </ul>
    <div class="workPerson">
        <div class="workPerson_tabs">
            <!-- <div class="workPerson_tabs_list" :class="{'active':tabActive=='gd'}" @click="tabClick('gd')">
                <img src="../../assets/images/file_list_2_line@1x.png" alt="">
                <img class="active" src="../../assets/images/file_list_2_line@1x-1.png" alt="">
                <span>工单</span>
            </div>
            <div class="workPerson_tabs_list" :class="{'active':tabActive=='ry'}" @click="tabClick('ry')">
                <img src="../../assets/images/user_6_line@1x-1.png" alt="">
                <img class="active" src="../../assets/images/user_6_line@1x.png" alt="">
                <span>人员</span>
            </div> -->
            <p class="workPerson_title" v-text="tabLabel"></p>
            <template v-if="tabActive=='tc'">
                <i class="workPreview" v-if="layerIndex==1" :class="previewAll?'preview_open':'preview_close'"
                   style="right:16px;" @click="previewActive"></i>
                <div class="personalInfo_close" v-if="layerIndex == 2" @click="returnLayerList">
                    <el-icon>
                        <ArrowLeft/>
                    </el-icon>
                    <span>返回</span>
                </div>
            </template>
        </div>
        <div class="workPerson_main" :style="{'height':mainHeight+'px','display':tabActive?'block':'none'}">
            <div class="runMap_datetimerange" v-show="['gd','ry'].includes(tabActive)">
                <el-date-picker
                    v-model="datetimerange"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="YYYY/MM/DD HH:mm"
                    value-format="YYYY-MM-DD HH:mm"
                />
            </div>
            <div class="workPerson_gd" :style="{'display':tabActive=='gd'?'block':'none'}">
                <div class="workPerson_gd_tabs">
                    <ul>
                        <li :class="{'active':gdTabsactive=='wg'}" @click="gdTab('wg')">网格</li>
                        <!--<li :class="{'active':gdTabsactive=='12345'}" @click="gdTab('12345')">12345</li>-->
                    </ul>
                </div>
                <div class="workPerson_gd_con">
                    <div class="workPerson_gd_title">工单状态</div>
                    <ul class="workPerson_gd_title_radio">
                        <li v-for="item in gdztSelect" :key="item.value" :class="{'active':gdRadioActive==item.value}"
                            @click="gdRadio(item.value)">{{item.label}}
                        </li>
                        <!--<li :class="{'active':gdRadioActive=='xgd1'}" @click="gdRadio('xgd1')">新工单</li>-->
                    </ul>
                    <div class="workPerson_gd_title">工单类型</div>
                    <el-cascader
                        class="workPerson_gd_select"
                        placeholder="请选择"
                        v-model="gdFormData.gdSjlx"
                        :options="gdlxSelect"
                        :props="cascaderProps"
                        filterable
                    />
                    <div class="workPerson_gd_title">承办部门</div>
                    <el-cascader
                        class="workPerson_gd_select"
                        placeholder="请选择"
                        v-model="gdFormData.czFpdxid"
                        :options="czFpdxidSelect"
                        :props="cascaderProps"
                        filterable
                    />
                    <div class="workPerson_gd_line"></div>
                    <div class="workPerson_gd_btn">
                        <!--<div class="workPerson_gd_btn_all" @click="">全部</div>-->
                        <div>
                            <div class="workPerson_gd_btn_all" @click="gdRest">重置</div>
                            <div class="workPerson_gd_btn_sure" @click="gdSearch">确定</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="workPerson_ry" :style="{'display':tabActive=='ry'?'block':'none'}">
                <el-input
                    v-model="ryFormData.name"
                    class="workPerson_ry_search"
                    placeholder="人员搜索"
                    :prefix-icon="Search"
                    @input="rySearch"
                />
                <div class="workPerson_ry_all">
                    <span>总计</span>
                    <span>{{tyTreeObj.clockin}} / {{tyTreeObj.count}}</span>
                </div>
                <div class="workPerson_ry_tree">
                    <el-scrollbar height="100%">
                        <div class="workPerson_ry_treeChild" :class="{'active':ryTreeIndex==item.deptid}"
                             @click="ryTree(item.deptid)"
                             v-for="item in tyTreeObj.list" :key="item.deptid">
                            <div class="workPerson_ry_tree_father">
                                <div class="workPerson_ry_tree_fatherLeft">
                                    <img class="workPerson_ry_tree_down"
                                         src="../../assets/images/arrow_down_triangle_fill@1x.png" alt="">
                                    <img class="workPerson_ry_tree_up"
                                         src="../../assets/images/arrow_up_triangle_fill@1x.png" alt="">
                                    <img class="workPerson_ry_tree_sq" src="../../assets/images/Frame348@1x.png" alt="">
                                    <span :title="item.deptname">{{item.deptname}}</span>
                                </div>
                                <div class="workPerson_ry_tree_fatherRight">
                                    {{item.clockin}} / {{item.count}}
                                </div>
                            </div>
                            <ul>
                                <li @click.stop="ryTreeChild(item1)" v-for="item1 in item.children"
                                    :key="item1.userid">
                                    <div class="workPerson_ry_tree_liL">
                                        <img v-show="!item1.time" src="../../assets/images/people_n.png" alt="">
                                        <img v-show="item1.time" src="../../assets/images/ry_people@1x.png" alt="">
                                        <span>{{item1.username}}</span>
                                    </div>
                                    <div class="workPerson_ry_tree_liR">
                                        {{item1.time}}
                                    </div>
                                </li>
                                <!--<li :class="{'active':ryTreeChildKey=='0-1'}" @click.stop="ryTreeChild('0-1')">-->
                                <!--<div class="workPerson_ry_tree_liL">-->
                                <!--<img src="../../assets/images/ry_people@1x-1.png" alt="">-->
                                <!--<img src="../../assets/images/ry_people@1x.png" alt="">-->
                                <!--<span>王唯依</span>-->
                                <!--</div>-->
                                <!--<div class="workPerson_ry_tree_liR">-->
                                <!--2021-09-20 18:18-->
                                <!--</div>-->
                                <!--</li>-->
                            </ul>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="workPerson_ry_rest">
                    <div>
                        重置
                    </div>
                </div>
            </div>
            <div class="workPerson_tc" :style="{'display':tabActive=='tc'?'flex':'none'}">
                <el-input
                    v-model="layerSearch"
                    class="workPerson_ry_search"
                    placeholder="请输入图层搜索"
                    :prefix-icon="Search"
                    clearable
                    @change="searchLayer"
                />
                <el-scrollbar height="100%">
                    <ul class="oneLevel" v-if="layerIndex == 1">
                        <li v-for="(item,index) in showLayerList" :key="index">
                            <span v-text="item.tc_name" :title="item.tc_name"></span>
                            <p @click="getTwoLevel(item)"><i></i>列表</p>
                            <i class="workPreview" :class="item.show==1?'preview_open':'preview_close'"
                               @click="oneLevelView(item)"></i>
                        </li>
                    </ul>
                    <ul class="twoLevel" v-if="layerIndex == 2">
                        <li v-for="(item,index) in showLayerList" :key="index">
                            <p class="title"><span>{{item.mc}}</span><i class="workPreview"
                                                                        :class="item.show==1?'preview_open':'preview_close'"
                                                                        @click="twoLevelView(item)"></i></p>
                            <p class="info mt_16">坐标：{{item.jwd}}</p>
                            <p class="info mt_8" v-if="item.sz">面积：{{item.sz}}平方米</p>
                        </li>
                    </ul>
                </el-scrollbar>
                <el-pagination
                    v-model:current-page="layerCurrentPage"
                    :page-size="10"
                    layout="total, prev, pager, next"
                    :total="layerList.length"
                    :pager-count="3"
                    @current-change="changePagination"
                />
            </div>
        </div>
    </div>
    <div class="personalInfo" :style="{'display':personTrack,'height':mainHeight+40+'px'}">
        <!-- <el-icon color="#09244B" class="personalInfo_close" @click="closePersonalInfo">
            <CircleCloseFilled/>
        </el-icon> -->
        <div class="personalInfo_close" @click="closePersonalInfo">
            <el-icon>
                <ArrowLeft/>
            </el-icon>
            <span>返回</span>
        </div>
        <div class="personalInfo_title" v-if="ryLinkWorkPersonal">
            <div class="personalInfo_title_name">{{ryLinkWorkPersonal.username}}</div>
            <div class="personalInfo_title_sq">{{ryLinkWorkPersonal.deptname}}</div>
            <div class="personalInfo_title_time">
                <div class="personalInfo_title_timeL">
                    <img src="../../assets/images/time_line@1x.png" alt="">
                    <span>{{ryLinkWorkPersonal.time}}</span>
                </div>
                <div class="personalInfo_title_timeR" @click=" track(ryLinkWorkPersonal.userid)">
                    <img src="../../assets/images/guiji.png" alt="">
                    <span>轨迹</span>
                </div>
            </div>
        </div>
        <div class="personalInfo_talbe">
            <div class="personalInfo_talbe_list" v-for="item in ryLinkWorkArray" :key="item.gdId"
                 @click="tableClickToGjMarker(item)">
                <div class="personalInfo_talbe_list_name">
                    {{item.gdBt}}
                </div>
                <div class="personalInfo_talbe_list_time">
                    <div class="personalInfo_talbe_list_timeL">
                        <img src="../../assets/images/time_line@1x.png" alt="">
                        <span>{{item.updateTime}}</span>
                    </div>
                    <div class="personalInfo_talbe_list_timeR">
                        <div></div>
                        <span>{{item.formKeyDic}}</span>
                    </div>
                </div>
            </div>
            <div class="personalInfo_talbe_list" style="text-align: center"
                 v-if="!ryLinkWorkArray || ryLinkWorkArray.length<1">
                没有数据
            </div>
        </div>
        <el-pagination
            v-model:current-page="ryLinkWork.pageNum"
            :page-size="ryLinkWork.pageSize"
            layout="total, prev, pager, next"
            :total="ryLinkWorkTotal"
            :pager-count="3"
            @current-change="handleCurrentChange"
        />
    </div>
    <!--<el-dialog v-model="dialogFormVisible" class="workPersonDialog">-->
    <!--<template #header="{ titleId, titleClass }">-->
    <!--<div class="my-header">-->
    <!--<img src="../../assets/images/Frame348.png" alt="">-->
    <!--<p :id="titleId" :class="titleClass" v-text="dialogData[0].zd_title"></p>-->
    <!--</div>-->
    <!--</template>-->
    <!--<el-scrollbar class="dialogScroll">-->
    <!--<ul>-->
    <!--<li v-for="(item,index) in dialogData" :key="index">-->
    <!--<span>{{item.zd_name}}：</span>-->
    <!--<span v-text="item.xx_content"></span>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</el-scrollbar>-->
    <!--</el-dialog>-->
    <div class="workPersonDialog" v-if="dialogFormVisible">
        <div class="workPersonDialog_main">
            <div class="workPersonDialog_title">
                <div class="workPersonDialog_title_name">
                    <img src="../../assets/images/mapModalTittle.png" alt="">
                    <span>{{dialogData.tcData.tc_name}}</span>
                </div>
                <img src="../../assets/images/close_circle_fill.png" alt="" @click="dialogFormVisible = false">
            </div>
            <div class="workPersonDialog_content">
                <div class="workPersonDialog_tcxx">
                    <div class="workPersonDialog_tcxx_tilte">
                        图层信息
                    </div>
                    <div>
                        <div class="workPersonDialog_tcxx_item">
                            <div class="workPersonDialog_tcxx_label">
                                名称：
                            </div>
                            <div class="workPersonDialog_tcxx_input">
                                {{dialogData.tcData.mc}}
                            </div>
                        </div>
                        <div class="workPersonDialog_tcxx_item">
                            <div class="workPersonDialog_tcxx_label">
                                备注：
                            </div>
                            <div class="workPersonDialog_tcxx_input">
                                {{dialogData.tcData.bz}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="workPersonDialog_tcxx">
                    <div class="workPersonDialog_tcxx_tilte">
                        联系信息
                    </div>
                    <el-scrollbar max-height="200px">
                        <div>
                            <div class="workPersonDialog_tcxx_item" v-for="item in dialogData.lxData">
                                <div class="workPersonDialog_lxxx_label">
                                    {{item.zd_name}}
                                </div>
                                <div class="workPersonDialog_tcxx_input">
                                    {{item.xx_content}}
                                </div>
                            </div>

                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, watch} from 'vue'
    import {Search} from '@element-plus/icons-vue'
    import * as  mapFunction from '../../assets/js/runMap.js';
    import _ from 'lodash'

    export default {
        name: "WorkPerson",
        props: ["mapComplete"],
        setup(props, context) {
            const {proxy} = getCurrentInstance();
            let tabActive = ref("gd");
            let tabLabel = ref("工单");
            const tabClick = (param) => {
                tabActive.value = param.value;
                tabLabel.value = param.label
                personTrack.value = "none"; // 关闭人员二级弹框

                if (layerList.value) {
                    layerList.value.forEach((e) => e.layer.hide())
                }
                if (param.value == "gd") {
                    gdSearch()
                } else if (param.value == "ry") {
                    ryTreeData()
                } else if (param.value == "tc") {
                    previewAll.value = false
                    getLayerList()
                }
            }
            let mainHeight = ref()
            let gdTabsactive = ref("wg")
            const gdTab = (param) => {
                gdTabsactive.value = param

            }
            let gdRadioActive = ref("")
            const gdRadio = (param) => {
                gdRadioActive.value = param
                gdFormData.value.tzlx = param;
            }
            // 左侧导航
            const leftSidebar = [
                {nav: '工单', label: '工单', svg: '', value: 'gd',},
                {nav: '人员', label: '人员管理', svg: '', value: 'ry',},
                // {nav: '图层', label: '图层管理', svg: '', value: 'tc',},
            ]

            //时间
            const datetimerange = ref([]);
            //默认时间
            const defaultTime = () => {
                let time1 = new Date();
                let year = time1.getFullYear();
                let month = (time1.getMonth() + 1) < 10 ? "0" + (time1.getMonth() + 1) : (time1.getMonth() + 1);
                let day1 = time1.getDate() < 10 ? "0" + time1.getDate() : time1.getDate();
                let hour = time1.getHours() < 10 ? "0" + time1.getHours() : time1.getHours(); //得到小时
                let minu = time1.getMinutes() < 10 ? "0" + time1.getMinutes() : time1.getMinutes(); //得到分钟
                let datetimerange1 = year + "-" + month + "-" + day1 + " " + hour + ":" + minu
                let time2 = new Date();
                time2.setTime(time1.getTime() - 3600 * 24 * 1000);
                let day2 = time2.getDate() < 10 ? "0" + time2.getDate() : time2.getDate();
                let datetimerange2 = year + "-" + month + "-" + day2 + " " + hour + ":" + minu
                datetimerange.value[0] = datetimerange2;
                datetimerange.value[1] = datetimerange1;
            }
            //工单
            const gdFormData = ref({
                isMap: 1,
                gdCjsj_start: datetimerange.value[0],
                gdCjsj_end: datetimerange.value[1],
                tzlx: "",
                gdSjlx: "",
                czFpdxid: "",
            })
            let cascaderProps = ref({
                emitPath: false
            })
            //工单查询
            const gdSearch = () => {
                proxy.$axios.post("/jgfast/wgsj/yxdt_selGdxx", gdFormData.value).then((res) => {
                    if (res.data && Array.isArray(res.data)) {
                        mapFunction.gdMarker(res.data)
                    } else {
                        mapFunction.gdMarker([])
                    }
                });
            }
            //工单重置
            const gdRest = () => {
                gdFormData.value.tzlx = "";
                gdFormData.value.gdSjlx = "";
                gdFormData.value.czFpdxid = "";
                gdRadioActive.value = ""
                defaultTime()
                gdSearch()
            }
            //人员查询
            let ryFormData = ref({
                name: "",
                startTime: datetimerange.value[0],
                endTime: datetimerange.value[1],
            })
            let ryTreeIndex = ref()
            const ryTree = (param) => {
                if (ryTreeIndex.value != param) {
                    ryTreeIndex.value = param;
                } else {
                    ryTreeIndex.value = ""
                }
            }
            let ryLinkWork = ref({
                czCzrid: "",
                czsj_start: datetimerange.value[0],
                czsj_end: datetimerange.value[1],
                pageNum: 1,
                pageSize: 10,
            })
            let ryLinkWorkArray = ref([])
            let ryLinkWorkTotal = ref();
            let ryLinkWorkPersonal = ref()
            const ryTreeChild = (param, flag = true) => {
                trackFlag = false;
                if (flag) {
                    ryLinkWork.value.czCzrid = param.userid;
                } else {
                    ryLinkWork.value.czCzrid = param;
                }
                proxy.$axios.post("/jgfast/wgsj/yxdt_selUserGdxx", ryLinkWork.value).then((res) => {
                    personTrack.value = "block"
                    ryLinkWorkTotal.value = res.data.rowsCount;
                    ryLinkWorkArray.value = res.data.vbs;
                    ryLinkWorkPersonal.value = res.data.clock;
                    trackAxiosData.value.czCzrid = res.data.clock.userid;
                });
                if (flag) {
                    mapFunction.clearGjMarker();
                    mapFunction.ryMarker(ryjwd.value)
                    mapFunction.ryMarkClick([param.dkjd, param.dkwd], param.time, param.userid)
                }
            }
            const rySearch = _.debounce(() => {
                ryTreeData()
            }, 1000)
            const handleCurrentChange = (param) => {
                ryLinkWork.pageNum = param;
                ryTreeChild()
            }
            let tyTreeObj = ref({})
            let ryjwd = ref();
            const ryTreeData = () => {
                proxy.$axios.post("/jgfast/sys/user/selDeptUserClockin", ryFormData.value).then((res) => {
                    tyTreeObj.value = res.data;
                    if (res.data && res.data.ryjwd && Array.isArray(res.data.ryjwd)) {
                        mapFunction.ryMarker(res.data.ryjwd)
                        ryjwd.value = res.data.ryjwd;
                    } else {
                        mapFunction.ryMarker([])
                    }
                });
            }
            //人员轨迹
            let personTrack = ref("none")
            //承办单位下拉选
            let czFpdxidSelect = ref([])
            //工单类型下拉选
            let gdlxSelect = ref([])
            //工单状态下拉选
            let gdztSelect = ref([])
            //监听地图加载完
            // watch(() => props.mapComplete, (newVal) => {
            //     if (newVal) {
            //         gdSearch();
            //         // ryTreeData();
            //     }
            // })
            //轨迹
            let trackAxiosData = ref({
                czCzrid: "",
                timeStart: datetimerange.value[0],
                timeEnd: datetimerange.value[1],
            })
            //是否已显示轨迹
            let trackFlag = false;
            const track = (prama) => {
                // trackAxiosData.value.czCzrid = prama;
                trackFlag = true;
                proxy.$axios.post("/jgfast/wgsj/yxdt_selUserMapData", trackAxiosData.value).then((res) => {
                    if (res.data && Array.isArray(res.data)) {
                        mapFunction.gjMarker(res.data)
                    } else {
                        mapFunction.gjMarker([])
                    }
                });
            }
            //监听时间变化
            watch(() => [datetimerange.value, props.mapComplete], (newVal) => {
                if (newVal[0]) {
                    gdFormData.value.gdCjsj_start = newVal[0][0]
                    gdFormData.value.gdCjsj_end = newVal[0][1]
                    ryFormData.value.startTime = newVal[0][0];
                    ryFormData.value.endTime = newVal[0][1];
                    ryLinkWork.value.czsj_start = newVal[0][0];
                    ryLinkWork.value.czsj_end = newVal[0][1];
                    trackAxiosData.value.timeStart = newVal[0][0];
                    trackAxiosData.value.timeEnd = newVal[0][1];
                } else {
                    gdFormData.value.gdCjsj_start = ""
                    gdFormData.value.gdCjsj_end = ""
                    ryFormData.value.startTime = "";
                    ryFormData.value.endTime = "";
                    ryLinkWork.value.czsj_start = "";
                    ryLinkWork.value.czsj_end = "";
                    trackAxiosData.value.timeStart = "";
                    trackAxiosData.value.timeEnd = "";
                }
                if (newVal[1]) {
                    if (tabActive.value == "gd") {
                        gdSearch();
                    } else if (tabActive.value == "ry") {
                        ryTreeData();
                        personTrack.value = "none"
                    }
                }
            }, {deep: true})
            //关闭个人轨迹弹框
            const closePersonalInfo = () => {
                personTrack.value = "none";
                mapFunction.ryMarker(ryjwd.value)
            }
            //点击估计列表项使对应的地图点位居中放大
            const tableClickToGjMarker = (param) => {
                if (!trackFlag) {
                    //点击轨迹列表时地图上如果没有估计落点，就去请求一下落点数据
                    trackFlag = true;
                    proxy.$axios.post("/jgfast/wgsj/yxdt_selUserMapData", trackAxiosData.value).then((res) => {
                        if (res.data && Array.isArray(res.data)) {
                            mapFunction.gjMarker(res.data)
                        } else {
                            mapFunction.gjMarker([])
                        }
                        mapFunction.tableClickToGjMarker(param);
                    });
                } else {
                    mapFunction.tableClickToGjMarker(param);
                }

            }
            // 图层（父级）
            const layerList = ref([])
            const layerIndex = ref(1) // 级别（控制列表）
            const dialogFormVisible = ref(false) // 对话框
            const dialogData = ref([]) // 对话框数据
            let setClickListInfo = {} // 父级点击时存储的信息，用于搜索
            const getLayerList = async () => {
                if (layerIndex.value == 2) {
                    layerList.value.forEach((e) => e.layer.hide())
                }
                layerIndex.value = 1 // 层级
                previewAll.value = 1 // 眼睛（全选）
                await proxy.$axios.post("/jgfast/datawayapi/yxdt/tclb", {tc_name: layerSearch.value || ''}).then((res) => {
                    if (res.code == 0 && res.value) {
                        let list = Array.isArray(res.value) ? res.value : new Array(res.value)
                        proxy.$axios.get("/jgfast/datawayapi/yxdt/sytcjwd").then((res) => {
                            // 将图层列表与覆盖物中的id 进行比对赋值，分块储存
                            list.forEach(item => {
                                item.layer = []

                                res.value.m.forEach(info => {
                                    if (item.tc_id == info.tc_id) {
                                        let polygon = new AMap.Polygon({
                                            path: JSON.parse(info.jwd) || [],
                                            extData: {
                                                id: info.id,
                                                tc_id: info.tc_id,
                                                tc_type: item.tc_type,
                                                tc_title: info.mc
                                            }
                                        })
                                        polygon.on('click', async (e) => {
                                            await proxy.$axios.post("/jgfast/datawayapi/yxdt/txjtxx", {
                                                tx_id: e.target.De.extData.id,
                                                tc_type: e.target.De.extData.tc_type
                                            }).then((data) => {
                                                if (data.code == 0 && data.value) {
                                                    // data.value.forEach(v => v.zd_title = e.target.De.extData.tc_title)
                                                    dialogData.value = data.value
                                                    dialogFormVisible.value = true
                                                }
                                            });
                                        });

                                        item.layer.push(polygon)
                                    }
                                })
                                item.layer = new AMap.OverlayGroup(item.layer);

                                item.layer.setOptions({
                                    strokeColor: "#126AFE", // 线颜色
                                    strokeOpacity: 1, // 线透明度
                                    strokeWeight: 3,    // 线宽
                                    fillColor: "#1791fc", // 填充色
                                    fillOpacity: 0.35 // 填充透明度
                                });
                                mapFunction.add(item.layer);
                            })

                            if (list.length) {
                                layerList.value = list
                                changePagination(1)
                            }
                        });
                    }
                });
            }
            // 图层（子级）
            const getTwoLevel = async (params) => {
                // 隐藏所有集合
                if (layerIndex.value == 1) {
                    layerList.value.forEach((e) => e.layer.hide())
                }
                ;

                let obj = {}
                if (params) {
                    setClickListInfo.value = params
                    obj.tc_id = params.tc_id
                    obj.tc_type = params.tc_type
                    layerSearch.value = ""
                    params.layer.show()
                } else {
                    obj.tc_id = setClickListInfo.value.tc_id
                    obj.tc_type = setClickListInfo.value.tc_type
                    setClickListInfo.value.layer.show()
                }
                obj.mc = layerSearch.value

                await proxy.$axios.post("/jgfast/datawayapi/yxdt/tcxx", obj).then((res) => {
                    if (res.code == 0 && res.value) {
                        layerIndex.value = 2
                        // 单条数据时候为对象 ，转换
                        if (Array.isArray(res.value)) {
                            layerList.value = res.value
                        } else {
                            layerList.value = new Array(res.value)
                        }

                        if (params) {
                            layerList.value.map(e => e.layer = params.layer) // 添加父级中的集合
                        } else {
                            layerList.value.map(e => e.layer = setClickListInfo.value.layer)
                        }
                        changePagination(1)
                    }
                });
            }
            // 搜索
            const layerSearch = ref("") // 图层搜索
            const searchLayer = (e) => {
                if (e == null) layerSearch.value = "";
                for (let i = layerList.value.length - 1; i >= 0; i--) layerList.value[i].layer.hide();

                if (layerIndex.value == 1) {
                    getLayerList()
                } else {
                    getTwoLevel()
                }
            }
            // 返回一级
            const returnLayerList = () => {
                layerSearch.value = ''
                getLayerList()
            }
            // 分页
            const layerCurrentPage = ref(1)
            const showLayerList = ref([])
            const changePagination = (currentPage) => {
                layerCurrentPage.value = currentPage;
                if (currentPage == 1) showLayerList.value = layerList.value.slice(0, 10);

                // 当前页 - 1 * 页数 = 分割开始数 比如二页 - 1  = 1*page
                const startSize = (currentPage - 1) * 10;

                // 分割结束数 = 分割开始数 + 10
                showLayerList.value = layerList.value.slice(startSize, startSize + 10);

                // 如果处理后没有数据（删除了最后一页所有数据），则往前处理一页
                if (!showLayerList.value.length && currentPage > 1) {
                    changePagination(layerCurrentPage - 1);
                }
            }

            // 全部预览
            const previewAll = ref(false)
            const previewActive = () => {
                previewAll.value = !previewAll.value

                let list = layerList.value
                // 眼睛状态
                if (previewAll.value) {
                    for (let i = list.length - 1; i >= 0; i--) {
                        list[i].layer.show()
                        list[i].show = '1'
                    }
                } else {
                    for (let i = list.length - 1; i >= 0; i--) {
                        list[i].layer.hide()
                        list[i].show = '0'
                    }
                }
            }
            // 父级预览
            const oneLevelView = (params) => {
                if (params.show == 0) {
                    params.layer.show()
                    params.show = 1
                } else {
                    params.layer.hide()
                    params.show = 0
                }
            }
            // 子级预览
            const twoLevelView = (params) => {
                let arr = params.layer.ix

                if (params.show == 0) {
                    for (let i = arr.length - 1; i >= 0; i--) {
                        if (arr[i].De.extData.id == params.id) {
                            arr[i].show()
                            break;
                        }
                    }
                    params.show = 1
                } else {
                    for (let i = arr.length - 1; i >= 0; i--) {
                        if (arr[i].De.extData.id == params.id) {
                            arr[i].hide()
                            break;
                        }
                    }
                    params.show = 0
                }
            }


            onMounted(() => {
                let clientWidth = document.documentElement.clientWidth
                mainHeight.value = document.documentElement.clientHeight - 136 * clientWidth / 1920;
                window.addEventListener('resize', () => {
                    mainHeight.value = document.documentElement.clientHeight - 136 * clientWidth / 1920;
                }, true);
                defaultTime()
                //获取代码表
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable": "cdg_wgsjlx,cdg_gdtzlx"
                }).then((res) => {
                    gdlxSelect.value = res.data.cdg_wgsjlx;
                    gdztSelect.value = res.data.cdg_gdtzlx;
                });
                //承办部门select查询
                proxy.$axios.post("/jgfast/wgsj/selCbdw").then((res) => {
                    czFpdxidSelect.value = res.data
                });
                window.ryTreeChild = ryTreeChild;
            })
            return {
                tabActive,
                tabLabel,
                tabClick,
                mainHeight,
                datetimerange,
                gdTab,
                gdTabsactive,
                gdRadioActive,
                gdRadio,
                Search,
                ryTree,
                ryTreeIndex,
                ryTreeChild,
                gdSearch,
                personTrack,
                czFpdxidSelect,
                gdFormData,
                gdlxSelect,
                gdztSelect,
                gdRest,
                cascaderProps,
                ryFormData,
                tyTreeObj,
                ryLinkWorkArray,
                ryLinkWorkTotal,
                ryLinkWork,
                handleCurrentChange,
                ryLinkWorkPersonal,
                track,
                rySearch,
                closePersonalInfo,
                tableClickToGjMarker,
                leftSidebar,
                layerList,
                getLayerList,
                showLayerList,
                layerSearch,
                layerCurrentPage,
                changePagination,
                searchLayer,
                previewActive,
                previewAll,
                getTwoLevel,
                layerIndex,
                oneLevelView,
                twoLevelView,
                returnLayerList,
                dialogFormVisible,
                dialogData
            }
        }
    }
</script>

<style scoped>

</style>
